




















































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import StatusLokalis from "@/components/pemeriksaan/assesmen/StatusLokalis.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import Editor from "vue-image-markup";

@Component({
  components: {
    StatusLokalis,
    Editor
  }
})
export default class Lokalis extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Ref() readonly editor;
  sess_login = userModule.user;
  getparam = {
    reg: this.register,
    unit_id: this.sess_login.unit_id
  };
  lokalis = {
    imageUrl: require("@/assets/img/body_w.png"),
    catatan: ""
  };
  canvasWidth = 728;
  canvasHeight = 600;
  mounted() {
    this.editor.set(this.editor.mode, this.editor.options);
    console.log("editor ", this.editor.options);
    this.editor.setBackgroundImage(this.lokalis.imageUrl);
  }
  freeDrawing() {
    const customizeFreeDrawing = { stroke: "black", strokeWidth: 3 };
    this.editor.set("freeDrawing", customizeFreeDrawing);
  }
  textMode() {
    const textModeOptions = {
      id: "title",
      fill: "black",
      fontFamily: "Verdana",
      fontSize: 13,
      placeholder: "Type something"
    };
    this.editor.set("text", textModeOptions);
  }
  selectMode() {
    this.editor.set("selectMode");
  }
  arrowMode() {
    const customizeArrow = { stroke: "red", strokeWidth: 2 };
    this.editor.set("arrow", customizeArrow);
  }
  eraseMode() {
    this.editor.set("eraser");
  }
  undoMode() {
    this.editor.undo();
  }
  clearMode() {
    this.editor.clear();
    this.editor.setBackgroundImage(this.lokalis.imageUrl);
  }
  redoMode() {
    this.editor.redo();
  }
  saveImage() {
    this.editor.saveImage();
  }
  setLokalis(v) {
    this.lokalis.catatan = v;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  @Watch("stateAsesmenAwal")
  valLokalis(val) {
    if (!this.stateAsesmenAwal || !this.stateAsesmenAwal["status_lokalis"]) {
      this.lokalis = {
        imageUrl: this.lokalis.imageUrl,
        catatan: ""
      };
      this.editor.setBackgroundImage(this.lokalis.imageUrl);
    } else {
      this.lokalis = {
        imageUrl: val["status_lokalis"].gambar,
        catatan: val["status_lokalis"].catatan
      };
      this.editor.setBackgroundImage(this.lokalis.imageUrl);
    }
  }
  @Watch("lokalis.catatan")
  changeLokalis(val) {
    console.log("lok");
    const lokal = {
      catatan: this.lokalis.catatan,
      gambar: this.editor.saveImage(),
      st: "ctt"
    };
    this.$emit("lokalis", lokal);
  }
  @Watch("lokalis.imageUrl")
  changeEditor(val) {
    console.log("edt");
    const lokal = {
      catatan: this.lokalis.catatan,
      gambar: this.editor.saveImage(),
      st: "gbr"
    };
    this.$emit("lokalis", lokal);
  }
  blur() {
    const lokal = {
      catatan: this.lokalis.catatan,
      gambar: this.editor.saveImage(),
      st: "gbr"
    };
    this.$emit("lokalis", lokal);
  }
}
